export default __webpack_public_path__ + "static/media/alleviation.29df77b8.jpg";